import { t } from "@lingui/macro";
import { ErrorMessage } from "@reactive-resume/utils";
import { deepSearchAndParseDates } from "@reactive-resume/utils";
import _axios from "axios";
import { redirect } from "react-router";

import { USER_KEY } from "../constants/query-keys";
import { toast } from "../hooks/use-toast";
import { translateError } from "../services/errors/translate-error";
import { queryClient } from "./query-client";

export const axios = _axios.create({ baseURL: "/api", withCredentials: true });

// Intercept responses to transform ISO dates to JS date objects
axios.interceptors.response.use(
  (response) => {
    const transformedResponse = deepSearchAndParseDates(response.data, ["createdAt", "updatedAt"]);
    return { ...response, data: transformedResponse };
  },
  async (error) => {
    const message = error.response?.data.message as ErrorMessage;
    const description = translateError(message);

    // If 401 Unauthorized, redirect to login
    if (error.response?.status === 401) {
      await queryClient.invalidateQueries({ queryKey: USER_KEY });
      redirect("/auth/login");
      return Promise.reject(new Error(message));
    }

    if (description) {
      toast({
        variant: "error",
        title: message === ErrorMessage.ResumeLimitReached ? t`Limit Reached` : t`Oops, the server returned an error.`,
        description,
      });
    }

    return Promise.reject(new Error(message));
  },
);
